import { isFetchResultSuccessful } from '@/entities/FetchResult'
import { Period } from '@/entities/Period/Period'
import { downloadShiftsIcalApiCall, fetchScheduleShiftsApiCall } from '@/entities/Shift/ShiftService'
import { transformScheduleShift } from '@/entities/Shift/ShiftTransformers'
import { TypedDispatch } from '@/redux/store'

import { setError, setIsLoading, setIsSuccessful, setScheduleShifts } from './shiftsReducer'

export const downloadShiftsIcal = (userUuid: string, period: Period) => async (dispatch: TypedDispatch): Promise<void> => {
    dispatch(setIsLoading(true))
    dispatch(setError(''))

    try {
        const response = await downloadShiftsIcalApiCall(userUuid, period)

        if (! isFetchResultSuccessful(response)) {
            dispatch(setError(response.error))

            return
        }

        dispatch(setIsSuccessful(true))
    } catch (error) {
        console.error('[downloadShiftsIcal]', error)
    }

    dispatch(setIsLoading(false))
}

export const getScheduleShifts = (
    startDate: Date,
    endDate: Date,
) => async (dispatch: TypedDispatch): Promise<void> => {
    dispatch(setIsLoading(true))
    dispatch(setError(''))

    try {
        const response = await fetchScheduleShiftsApiCall(startDate, endDate)

        if (! isFetchResultSuccessful(response)) {
            dispatch(setError(response.error))

            return
        }

        const scheduleShifts = response.data.map(scheduleShiftResource => transformScheduleShift(scheduleShiftResource))

        dispatch(setScheduleShifts(scheduleShifts))
    } catch (error) {
        console.error('[getShifts]', error)
    }

    dispatch(setIsLoading(false))
}
